module.exports = __webpack_public_path__ + "img/share6.7fd7f962.png";